import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { DashboardHeader } from "@/components/dashboard/ops";
import OwnerDashboard from "@/components/dashboard/OwnerDashboard";
import { ManagerDashboard, CashierDashboard } from "@/components/dashboard/StaffDashboards";

// Build B: role-aware dashboard. The payload from GET /dashboard is already role-scoped server-side
// (manager/cashier never receive monetary keys); the role switch here only picks the matching layout.
export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/dashboard").then((r) => setStats(r.data)).catch(() => {}); }, [user?.role]);

  const Body = user?.role === "owner" ? OwnerDashboard : user?.role === "manager" ? ManagerDashboard : CashierDashboard;
  return (
    <div className="space-y-8" data-testid="dashboard" data-role={user?.role}>
      <DashboardHeader />
      <Body stats={stats} />
    </div>
  );
}
